export const PROVIDERS = {
  ollama: { name: "Ollama", base: "http://localhost:11434" },
  lmstudio: { name: "LM Studio", base: "http://localhost:1234" },
};

export async function listExternalModels(base) {
  const res = await fetch(`${base.replace(/\/$/, "")}/v1/models`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const data = await res.json();
  return (data.data || []).map((m) => m.id);
}

export async function streamExternal(base, model, messages, onDelta, signal) {
  const res = await fetch(`${base.replace(/\/$/, "")}/v1/chat/completions`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ model, messages, stream: true, temperature: 0.6 }),
    signal,
  });
  if (!res.ok || !res.body) throw new Error(`HTTP ${res.status}`);
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  let full = "";
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const lines = buf.split("\n");
    buf = lines.pop();
    for (const line of lines) {
      const l = line.trim();
      if (!l.startsWith("data:") || l === "data: [DONE]") continue;
      try {
        full += JSON.parse(l.slice(5)).choices?.[0]?.delta?.content || "";
        onDelta(full);
      } catch (e) {
        console.warn("Fragment de flux ignoré", e);
      }
    }
  }
  return full;
}
